import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import searchParamString from '@/utils/schema/searchParamString'

export interface RestaurantId {
  restaurant_id: string
}

const DEFAULT_VALUES = {
  restaurantId: '',
  menuItemId: '',
  q: '',
}

const indexSearchSchema = type({
  restaurantId: searchParamString.default(DEFAULT_VALUES.restaurantId),
  menuItemId: searchParamString.default(DEFAULT_VALUES.menuItemId),
  q: searchParamString.default(DEFAULT_VALUES.q),
})

export const Route = createFileRoute('/_food-grubhub/restaurant/$restaurantId/')({
  validateSearch: indexSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
